
interface AboutSectionProps {
  language: 'es' | 'en';
}

export default function AboutSection({ language }: AboutSectionProps) {
  const content = {
    es: {
      title: 'Conoce a Juampi',
      subtitle: 'Fundador de First Step Japan',
      description: 'Emprendedor argentino viviendo en Osaka.',
      skills: 'Fluente en español e inglés.',
      mission: 'Mi misión es hacer que el proceso de llegada a Japón sea simple, humano y acompañado, especialmente para quienes hablan español y buscan sentirse en casa.',
      experience: 'Pasé por el mismo camino que hoy recorren muchos extranjeros: los trámites, la adaptación y el idioma. Por eso sé lo importante que es sentirse acompañado desde el primer día.',
      stat1: 'Acompañamiento en trámites municipales y legales',
      stat2: 'Creación de CV japonés personalizado',
      stat3: 'Asesoramiento en vivienda y vida práctica',
      stat4: 'Comunicación trilingüe (español, inglés y japonés)'
    },
    en: {
      title: 'Meet Juampi',
      subtitle: 'Founder of First Step Japan',
      description: 'Argentine entrepreneur living in Osaka.',
      skills: 'Fluent in Spanish and English.',
      mission: 'My mission is to make the process of arriving in Japan simple, human, and supported, especially for Spanish-speaking people who want to feel at home.',
      experience: 'I went through the same path many newcomers experience: paperwork, adaptation, and language barriers. That\'s why I know how important it is to feel supported from day one.',
      stat1: 'Assistance with municipal and legal procedures',
      stat2: 'Personalized Japanese CV creation',
      stat3: 'Housing and practical life guidance',
      stat4: 'Communication in Spanish, English, and Japanese'
    }
  };

  return (
    <section id="about" className="py-20 bg-gradient-to-br from-red-50 to-yellow-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-4">
              {content[language].title} 🤝
            </h2>
            <p className="text-xl text-red-700 font-medium">
              {content[language].subtitle}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/48ff209ee73fb0e306febf7d6a2e4fef/263de25664f02ac8e7c5b50ddfcb4ee4.jpeg"
                  alt="Juampi - Fundador de First Step Japan"
                  className="w-full h-auto object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-red-600/20 to-transparent"></div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center text-2xl shadow-lg">
                🇦🇷
              </div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-2xl shadow-lg">
                🇯🇵
              </div>
            </div>

            {/* Content */}
            <div className="space-y-6">
              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-red-600">
                  {content[language].description}
                </h3>
                <p className="text-lg text-gray-700">
                  {content[language].skills}
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {content[language].mission}
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  {content[language].experience}
                </p>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-1 gap-4 pt-6">
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">🏯</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat1}</div>
                </div>
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">📄</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat2}</div>
                </div>
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">🏠</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat3}</div>
                </div>
                <div className="flex items-center p-4 bg-white rounded-xl shadow-md">
                  <div className="text-2xl mr-4">💬</div>
                  <div className="text-sm text-gray-700 font-medium">{content[language].stat4}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
